/* eslint-disable react/no-array-index-key */

import { useRef } from 'react';
import { useInView, motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

export const TrustSection = () => {
  const { t } = useTranslation();

  const ref = useRef(null);

  const isInView = useInView(ref, { margin: '-100px', once: false });

  const cards = [
    {
      icon: '/images/icons/check-circle.svg',
      subtitle: t('whyRixsus.features.approvalRate.subTitle'),
      title: t('whyRixsus.features.approvalRate.title'),
      titleValue: '-',
      value: '97%',
    },
    {
      icon: '/images/icons/speed.svg',
      subtitle: t('whyRixsus.features.speed.subTitle'),
      title: t('whyRixsus.features.speed.title'),
      titleValue: t('whyRixsus.features.speed.titleValue'),
      value: '500ms',
    },
    {
      icon: '/images/icons/uptime.svg',
      subtitle: t('whyRixsus.features.uptime.subTitle'),
      title: t('whyRixsus.features.uptime.title'),
      titleValue: '-',
      value: '99.8%',
    },
    {
      icon: '/images/icons/rocket.svg',
      subtitle: t('whyRixsus.features.integration.subTitle'),
      title: t('whyRixsus.features.integration.title'),
      titleValue: t('whyRixsus.features.integration.titleValue'),
      value: '2 weeks',
    },
  ];

  return (
    <section
      id="why"
      ref={ref}
      className="bg-[#F1F8FB] py-12 px-6 font-sans rounded-[16px] max-w-[1204px] mx-auto w-full scroll-mt-[200px] sm:scroll-mt-[300px] lg:scroll-mt-[120px]"
    >
      <div>
        <div className="text-center mb-12">
          <p className="text-[#005FCC] text-[12px] sm:text-[14px] leading-[17px] font-bold uppercase">
            {t('common.why')}
          </p>
          <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-gray-800">
            {t('whyRixsus.subTitle')}
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-6 justify-items-center">
          {cards.map((card, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 40 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ delay: index * 0.2, duration: 0.6 }}
              className="w-full max-w-[265px] h-auto rounded-[32px] sm:rounded-[40px] pt-4 px-2 sm:px-2 pb-4 bg-white shadow-md flex flex-col gap-4 sm:gap-6 text-left"
            >
              <img
                src={card.icon}
                alt={card.title}
                className="w-10 h-10 sm:w-12 sm:h-12"
              />
              <h3 className="text-[18px] md:text-[28px] leading-snug font-semibold text-[#232539]">
                {card.title}
              </h3>

              <p
                className={`text-xs sm:text-sm p-0 m-0 ${
                  card.titleValue === '-' ? 'text-transparent' : 'text-gray-500'
                }`}
                aria-hidden={card.titleValue === '-'}
              >
                {card.titleValue}
              </p>

              <p className="text-[32px] sm:text-[32px] md:text-[48px] leading-[40px] sm:leading-[48px] font-bold text-blue-600 mb-1">
                {card.value}
              </p>
              <p className="text-[14px] md:text-[16px] leading-[22px] sm:leading-[26px] text-gray-500 font-inter">
                {card.subtitle}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
